import { RouteSegments } from '../routingClientAdmin.interface';

export const generateRoutingProfileRoute = (id?: number) => {
  const pageUrl = `/${RouteSegments.Root.Config}/${RouteSegments.Config.Profiles}/${RouteSegments.Profiles.Routing}`;

  if (id) {
    return `${pageUrl}/${id}`;
  }

  return pageUrl;
};
